import React from "react";

export const PrevTerm7 = () => {
    return (
        <div className="previous-terms-content">
            {/* 1. 스마트올 중학_개인정보 처리방침(2024.08.28시행)_완료본_v2 */}
            <h1>개인정보 처리방침</h1>
            <br />
            <p>1. 개인정보의 처리에 관한 사항</p>
            <p>2. 14세 미만 아동의 개인정보 처리에 관한 사항</p>
            <p>3. 개인정보의 파기 절차 및 방법에 관한 사항</p>
            <p>4. 개인정보의 제3자 제공에 관한 사항</p>
            <p>5. 개인정보 처리업무의 위탁에 관한 사항</p>
            <p>6. 개인정보의 국외 수집 및 이전에 관한 사항</p>
            <p>7. 개인정보의 안전성 확보조치에 관한 사항</p>
            <p>8. 개인정보 자동 수집 장치의 설치 운영 및 거부에 관한 사항</p>
            <p>9. 정보주체와 법정대리인의 권리·의무 및 행사방법에 관한 사항</p>
            <p>10. 개인정보보호책임자의 성명 또는 개인정보 업무 담당부서에 관한 사항</p>
            <p>11. 정보주체의 권익침해에 대한 구제 방법</p>
            <p>12. 개인정보 처리방침의 변경에 관한 사항</p>
            <br />
            <p>
                주식회사 웅진씽크빅&#40;이하 &quot;회사&quot;라 한다&#41; 은 「개인정보 보호법」 및 「정보통신망
                이용촉진 및 정보보호 등에 관한 법률」을 준수하기 위하여 노력하고 있습니다. 회사는 개인정보 처리방침을
                통하여 고객님께서 제공하시는 개인정보를 어떠한 용도와 방식으로 이용하고 있으며, 개인정보보호를 위해
                어떠한 조치를 취하고 있는지 알려드립니다. 본 방침은 2025년 7월 4일부터 시행됩니다.
            </p>
            <div>
                <h2>1. 개인정보의 처리에 관한 사항</h2>
                <h3>회사는 서비스 이용 시 고객으로부터 아래와 같은 개인 정보를 처리하고 있습니다.</h3>
                <p>1) 정보주체의 동의를 받지 않고 처리하는 경우</p>
                <table>
                    <colgroup>
                        <col style={{ width: "25%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "20%" }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>목적</th>
                            <th>항목</th>
                            <th>보유 및 이용기간</th>
                            <th>법적 근거</th>
                        </tr>
                        <tr>
                            <td>계약의 체결·이행·관리·배송, 만14세 미만 아동 본인 확인, 현금영수증 발급 </td>
                            <td>
                                이름, 생년월일, 주소, 연락처, E-mail, 자녀정보&#40;이름, 생년월일, 학교명, 학년&#41;,
                                녹취자료
                            </td>
                            <td>계약종료 후 5년 &#40;전자상거래법 제6조&#41;</td>
                            <td>개인정보 보호법 제15조 제1항 제4호&#40;&#39;계약 이행&#39;&#41;</td>
                        </tr>
                        <tr>
                            <td>월 회비 정산·청구·수납·추심 </td>
                            <td>
                                결제정보&#40;결제일, 은행명, 예금주, 계좌번호 또는 카드명, 소유주, 카드유효기간,
                                카드번호&#41;
                            </td>
                            <td>계약종료 후 5년 &#40;전자상거래법 제6조&#41;</td>
                            <td>개인정보 보호법 제15조 제1항 제4호&#40;&#39;계약 이행&#39;&#41;</td>
                        </tr>
                        <tr>
                            <td>
                                고지사항 전달, 계약 이행을 위한 연락, 민원 등 고객 상담 처리, 서비스 만족도 조 사, 고객
                                맞춤형 서비스
                            </td>
                            <td>주소, 연락처, E- mail, 연령, 콘텐츠 사용이력</td>
                            <td>계약종료 후 5년 &#40;전자상거래법 제6조&#41;</td>
                            <td>개인정보 보호법 제15조 제1항 제4호&#40;&#39;계약 이행&#39;&#41;</td>
                        </tr>
                        <tr>
                            <td>수강권 구매하기</td>
                            <td>
                                부모정보&#40;이름, 연락처, 생년월일, 성별, 주소, E-mail&#41; 자녀정보&#40;이름, 연락처,
                                생년월일, 학년, 주소, E-mail&#41; 결제정보&#40;결제일, 은행명, 카드명, 소유주, 생년월일,
                                카드유효기간, 카드번호&#41;
                            </td>
                            <td>계약종료 후 5년 &#40;전자상거래법 제6조&#41;</td>
                            <td>개인정보 보호법 제15조 제1항 제4호&#40;&#39;계약 이행&#39;&#41;</td>
                        </tr>
                    </tbody>
                </table>

                <p>2) 정보주체의 동의를 받아 처리하는 경우</p>
                <table>
                    <colgroup>
                        <col style={{ width: "25%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "20%" }} />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>목적</th>
                            <th>항목</th>
                            <th>보유 및 이용기간</th>
                            <th>법적 근거</th>
                        </tr>
                        <tr>
                            <td>상담 또는 학습 신청</td>
                            <td>학부모명, 연락처</td>
                            <td>무료체험 종료일로부터 1년</td>
                            <td>개인정보 보호법 제15조 제1항 제1호&#40;&#39;동의&#39;&#41;</td>
                        </tr>
                        <tr>
                            <td>문자를 통한 맞춤 서비스 제공</td>
                            <td>이름, 연락처</td>
                            <td>동의 철회 시 또는 학습종료 후 1년</td>
                            <td>개인정보 보호법 제15조 제1항 제1호&#40;&#39;동의&#39;&#41;</td>
                        </tr>
                        <tr>
                            <td>신규서비스 개발, 서비스 이용 통계 및 설문</td>
                            <td>
                                이름, 성별, 생년월일, 연락처, 주소, E-mail, 자녀정보&#40;이름, 성별, 생년월일, 학년&#41;
                            </td>
                            <td>동의 철회 시 또는 학습종료 후 1년</td>
                            <td>개인정보 보호법 제15조 제1항 제1호&#40;&#39;동의&#39;&#41;</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <h2>2. 14세 미만 아동의 개인정보 처리에 관한 사항</h2>
                <h3>
                    1) 회사는 14세 미만 아동의 개인정보를 처리하기 위하여 동의가 필요한 경우에는 해당 아동의
                    법정대리인으로부터 동의를 받습니다.
                </h3>
                <h3>
                    2) 회사는 14세 미만 아동의 개인정보 처리에 관하여 그 법정대리인의 동의를 받을 때에는 아동에게
                    법정대리인의 성명, 연락처와 같이 최소한의 정보를 요구할 수 있으며, 동의 내용을 게재한 인터넷
                    사이트에 법정대리인이 동의 여부를 표시하도록 합니다.
                </h3>
            </div>

            <div>
                <h2>3. 개인정보의 파기 절차 및 방법에 관한 사항</h2>
                <h3>
                    1&#41; 회사는 원칙적으로 고객님의 삭제 요청, 개인정보 이용목적 달성, 개인정보 보유 및 이용기간의
                    경과 후 에는 해당 개인정보를 지체없이 파기합니다. 단, 고객님의 개인정보 보유기간에 대해 별도의
                    동의를 얻은 경우 또는 법령에서 일정 기간 보관 의무를 부과하는 경우에는 해당 기간 동안 개인정보를
                    별도의 데이터베이스&#40;DB&#41;로 옮기거나 보관장소를 달리하여 안전하게 보관합니다.
                </h3>
                <h3>파기 절차 및 방법</h3>
                <p>
                    - 전자적 파일 형태인 경우 복구 및 재생되지 않도록 안전하게 삭제하고, 종이 문서인 경우 분쇄하거나
                    소각하여 파기합니다.
                </p>
            </div>

            <div>
                <h2>4. 개인정보 제3자 제공에 관한 사항</h2>
                <h3>
                    회사는 이용자의 개인정보를 제1조&#40;개인정보 처리에 관한 사항&#41;에서 명시한 범위 내에서만
                    처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보보호법」 제17조 및 제18조에 해당하는
                    경우에만 개인정보를 제3자에게 제공합니다.
                </h3>
                <h3>1&#41; 정보주체의 동의를 받아 제공하는 경우.</h3>
                <table>
                    <tbody>
                        <tr>
                            <th>제공받는 자 </th>
                            <th>제공 목적</th>
                            <th>제공하는 개인정보 항목</th>
                            <th>제공 받는 자의 보유기간</th>
                            <th>법적 근거</th>
                        </tr>
                        <tr>
                            <td>나이스평가정보㈜</td>
                            <td> &#40;채권 발생 시에만 해당&#41; 채무불 이행 등재</td>
                            <td>이름, 성별, 법적생년월일, 주소, 연락처, 이메일, 결재 정보</td>
                            <td>채권 소멸 시까지</td>
                            <td>개인정보 보호법 제17조 제1항 제1호</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <h2>5. 개인정보 처리의 위탁에 관한 사항</h2>
                <h3>1&#41; 회사는 원활한 업무를 위하여 다음과 같이 개인정보 처리 업무를 위탁하고 있습니다.</h3>
                <table>
                    <tbody>
                        <tr>
                            <th>관계</th>
                            <th>수탁업체 명</th>
                            <th>위탁 업무</th>
                        </tr>
                        <tr>
                            <td>위탁</td>
                            <td>㈜웅진</td>
                            <td>클라우드 시스템 유지보수 및 관리, 고객센터 문의 대응</td>
                        </tr>
                        <tr>
                            <td>재위탁</td>
                            <td>Amazon Web Services</td>
                            <td>클라우드 인프라 제공</td>
                        </tr>
                        <tr>
                            <td>위탁</td>
                            <td>코리아크레딧뷰로&#40;주&#41;</td>
                            <td>휴대폰 본인인증</td>
                        </tr>
                        <tr>
                            <td>위탁</td>
                            <td>㈜크리젠솔루션</td>
                            <td>상담 녹취 시스템</td>
                        </tr>
                        <tr>
                            <td>위탁</td>
                            <td>㈜다우기술</td>
                            <td>문자메시지 전송, 카카오톡 알림톡 전송</td>
                        </tr>
                        <tr>
                            <td>위탁</td>
                            <td>금융결제원, 하이픈코퍼레이션, 한국정보통신</td>
                            <td>멤버십 월회비출금처리, ARS</td>
                        </tr>
                        <tr>
                            <td>위탁</td>
                            <td>나이스신용정보㈜, SCI평가정보㈜</td>
                            <td>미납 및 멤버십 해지 채권에 대한 수납 관리 및 채권 추심</td>
                        </tr>
                        <tr>
                            <td>위탁</td>
                            <td>㈜웅진북센</td>
                            <td>물품 배송</td>
                        </tr>
                        <tr>
                            <td>위탁</td>
                            <td>빛나는 교육㈜</td>
                            <td>패드 구매 대행 및 구매이력 확인&#40;AS시&#41;</td>
                        </tr>
                        <tr>
                            <td>위탁</td>
                            <td>리포나, MPGIO, 오션아이</td>
                            <td>A/S 및 리퍼비시</td>
                        </tr>
                    </tbody>
                </table>

                <h3>
                    2&#41; 회사는 위탁계약 체결 시 「개인정보보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리
                    금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을
                    계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
                </h3>
                <h3>
                    3&#41; 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보처리방침을 통하여 공개하도록
                    하겠습니다.
                </h3>
            </div>

            <div>
                <h2>6. 개인정보의 국외 수집 및 이전에 관한 사항</h2>
                <p>회사는 개인정보를 국외 수집 및 이전하지 않습니다.</p>
            </div>

            <div>
                <h2>7. 개인정보 안전성 확보 조치에 관한 사항</h2>
                <h3>
                    1&#41; 회사는 고객님의 개인정보 및 인공지능 학습데이터를 처리함에 있어 개인정보가 분실, 도난, 유출,
                    변조, 또는 훼손 되지 않도록 안전성 확보를 위하여 다음과 같은 기술적 대책을 강구하고 있습니다.
                </h3>
                <p>
                    - 개인정보처리시스템 등의 접근 권한 관리, 침입 탐지 및 차단 시스템 가동, 파일 및 전송데이터 암호화
                </p>
                <p>- 컴퓨터 바이러스에 의한 피해 방지를 위한 자동 Update 백신 이용</p>
                <h3>2&#41; 회사는 고객님의 개인정보보호를 위해 다음과 같은 관리적 조치를 취하고 있습니다. </h3>
                <p>
                    - 개인정보를 취급하는 직원을 최소한으로 줄이고, 정기 또는 수시 교육을 통해 개인정보보호정책을 준수하
                    도록 강조하고 있습니다.
                </p>
                <p>
                    - 모든 임직원 및 계약직 사원에게 보안서약서를 제출하게 함으로 사람에 의한 정보유출을 사전에 방지하고
                    있습니다.
                </p>
                <p>
                    - 위반 내용이 확인되는 경우 이를 시정 또는 개선하며 기타 필요한 조치를 취하기 위한 내부절차를 마련하
                    고 있습니다.
                </p>
                <h3>3&#41; 회사는 개인정보 및 인공지능 학습데이터를 위해 다음과 같은 물리적 조치를 취하고 있습니다.</h3>
                <p>- 전산실, 사무실 등의 접근통제, 제한구역의 보조저장매체 통제, 재해&#47;재난에 대한 안전조치 등</p>
            </div>

            <div>
                <h2>8. 개인정보 자동 수집 장치의 설치 운영 및 거부에 관한 사항</h2>
                <p>
                    회사는 개인화되고 맞춤화된 서비스를 제공하기 위해서 이용자의 정보를 저장하고 수시로 불러오는
                    &#39;쿠키&#40;cookie&#41;&#39;를 사용합니다.
                </p>
                <h3>1&#41; 쿠키&#40;cookie&#41;란?</h3>
                <p>
                    쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 아주 작은 텍스트 파일로 이
                    용자 컴퓨터의 하드디스크에 저장됩니다. 이후 이용자가 웹 사이트에 방문할 경우 웹 사이트 서버는 이용자
                    의 하드 디스크에 저장되어 있는 쿠키의 내용을 읽어 이용자의 환경설정을 유지하고 맞춤화된 서비스를 제
                    공하기 위해 이용됩니다.
                </p>
                <h3>2&#41; 쿠키 사용 목적</h3>
                <p>
                    회원과 비회원의 접속 빈도나 방문 시간 등의 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종
                    이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스를 제공하기 위해 쿠키를
                    사용합니다.
                </p>
                <h3>3&#41; 쿠키의 설치&#47;운영 및 거부 </h3>
                <p>
                    이용자는 쿠키 설치에 대한 선택권을 가지고 있으며, 웹브라우저별 옵션 설정을 통해 모든 쿠키를 허용 또
                    는 거부하거나, 쿠키가 저장될 때마다 확인을 거치도록 할 수 있습니다. 다만, 쿠키의 저장을 거부할
                    경우에 는 로그인이 필요한 회사의 일부 서비스는 이용에 어려움이 있을 수 있습니다.
                </p>
                <p>쿠키 설치 허용여부를 지정하는 방법</p>
                <p>- 크롬&#40;Chrome&#41; : 웹 브라우저 설정 &gt; 개인정보 보호 및 보안 &gt; 인터넷 사용 기록 삭제</p>
                <p>
                    - 엣지&#40;Edge&#41; : 웹 브라우저 설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트 데이터 관리 및
                    삭제
                </p>
            </div>

            <div>
                <h2>9. 정보주체와 법정대리인의 권리·의무 및 행사방법에 관한 사항</h2>
                <h3>
                    1&#41; 회사가 고객님의 개인정보에 대해 열람, 수정, 삭제, 처리정지, 동의철회 등의 요구가 있을 시 지체
                    없이 이를 처리합니다. 따라서 고객님은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의
                    개인정보를 열람 하거나 수정할 수 있으며 동의철회를 요청할 수도 있습니다.
                </h3>
                <h3>2&#41; 아래로 연락하시면 지체없이 대응하겠습니다.</h3>
                <p>▶ 개인정보 열람 등 청구 접수・처리 부서</p>
                <p>부서명: 고객센터</p>
                <p>연락처: 1577-1500</p>
                <h3>
                    3&#41; 고객님이 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해
                    개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정
                    처리 결과를 제3자에게 통지하여 정정이 이루어지도록 하겠습니다.
                </h3>
                <h3>
                    4&#41; 고객님의 요청에 의해 해지 또는 삭제된 개인정보는 수집 시 고지한 &#39;개인정보의 보유 및
                    이용기간&#39;에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고
                    있습니다.
                </h3>
                <p>단, 다음의 경우에는 요청을 제한 또는 거절할 수 있고, 회사는 이를 고객님께 지체없이 고지합니다.</p>
                <p>- 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한 경우</p>
                <p>
                    - 다른 사람의 생명, 신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할
                    우려가 있는 경우
                </p>
                <p>
                    - 개인정보를 처리하지 아니하면 회원과 약정한 서비스를 제공하지 못하는 등 계약의 이행이 곤란한
                    경우로서 회원이 그 계약의 해지의사를 명확하게 밝히지 아니한 경우
                </p>
            </div>

            <div>
                <h2>10. 개인정보보호책임자의 성명 또는 개인정보 업무 담당부서에 관한 사항</h2>
                <p>
                    회사는 회원의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이
                    개인정보보호책임자를 지정하고 있습니다.
                </p>
                <p>개인정보호책임자: 임한우 &#47; 상무</p>
                <p>개인정보 업무 담당부서: 정보보호파트</p>
                <p>연락처: &#40;고객센터&#41; 1577-1500</p>
            </div>

            <div>
                <h2>11. 정보주체의 권익침해에 대한 구제 방법</h2>
                <p>개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</p>
                <p>1&#41; 개인정보 분쟁조정위원회: &#40;국번없이&#41; 1833-6972 &#40;www.kopico.go.kr&#41;</p>
                <p>2&#41; 개인정보침해신고센터: &#40;국번없이&#41; 118 &#40;privacy.kisa.or.kr&#41;</p>
                <p>3&#41; 대검찰청: &#40;국번없이&#41; 1301 &#40;www.spo.go.kr&#41;</p>
                <p>4&#41; 경찰청: &#40;국번없이&#41; 182 &#40;ecrm.cyber.go.kr&#41;</p>
            </div>

            <div>
                <h2>12. 개인정보 처리방침의 변경에 관한 사항</h2>
                <p>2025년 7월 4일에 시행된 개인정보 처리방침의 주요 개정 내용은 아래입니다.</p>
                <table>
                    <tbody>
                        <tr>
                            <th>개정 전</th>
                            <th>개정 후</th>
                        </tr>
                        <tr>
                            <td>
                                <p>1. 개인정보의 처리에 관한 사항</p>
                                <p>1&#41; 개인 정보의 처리목적,항목,보유 및 이용기간</p>
                            </td>
                            <td>
                                <p>1. 개인정보의 처리에 관한 사항</p>
                                <p>1&#41; 정보주체의 동의를 받지 않고 처리하는 경우</p>
                                <p>2&#41; 정보주체의 동의를 받아 처리하는 경우</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>3. 개인정보 제3자 제공에 관한 사항</p>
                            </td>
                            <td>
                                <p>4. 개인정보의 제3자 제공에 관한 사항</p>
                                <p>1&#41; 정보주체의 동의를 받아 제공하는 경우</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>
                                    - Internet Explorer: &#91;도구&#93; &gt; &#91;인터넷 옵션&#93; &gt;
                                    &#91;개인정보&#93; 탭&gt; &#91;고급&#93; 설정
                                </p>
                                <p>- Microsoft Edge: &#91;설정&#93; &gt; &#91;쿠키 및 사이트 권한&#93; 설정</p>
                                <p>
                                    - Chrome: &#91;설정&#93; &gt; &#91;개인정보 및 보안&#93; &gt; &#91;쿠키 및 기타
                                    사이트 데이터&#93; 설정
                                </p>
                            </td>
                            <td>
                                <p>
                                    - 크롬&#40;Chrome&#41; : 웹 브라우저 설정 &gt; 개인정보 보호 및 보안 &gt; 인터넷
                                    사용 기록 삭제
                                </p>
                                <p>
                                    - 엣지&#40;Edge&#41; : 웹 브라우저 설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트
                                    데이터 관리 및 삭제
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p>10. 개인정보보호책임자의 성명 또는 개인정보 업무 담당부서에 관한 사항</p>
                                <p>개인정보보호책임자: 이수종</p>
                                <p>개인정보관리자: 김준환</p>
                            </td>
                            <td>
                                <p>10. 개인정보보호책임자의 성명 또는 개인정보 업무 담당부서에 관한 사항</p>
                                <p>개인정보보호책임자: 임한우 &#47; 상무</p>
                                <p>개인정보 업무 담당부서: 정보보호파트</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div>
                <h3>이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다.</h3>
                <p>- 2024. 08. 28 ~ 2025. 07. 03 적용</p>
                <p>- 2024. 04. 03 ~ 2024. 08. 27 적용</p>
                <p>- 2022. 11. 09 ~ 2024. 04. 02 적용</p>
                <p>- 2021. 07. 22 ~ 2022. 11. 08 적용</p>
                <p>- 2021. 06. 01 ~ 2021. 07. 21 적용</p>
                <p>- 2020. 12. 01 ~ 2021. 05. 31 적용</p>
            </div>
        </div>
    );
};
